import ObjectDisconnectionHelper from '@/Utility/Association/ObjectDisconnectionHelper';
import ComponentManager from '@/Management/ComponentManager';

export default class CreateOrConnectHelper extends ObjectDisconnectionHelper {

    public constructor(params: any) {
        super(params);
    }

    public ExecuteAction(): void {

    }
    
    /**
     * @override
     */
    public ExecuteCheck(): void {
        if (this.affectedObjectIds && this.affectedObjectIds.length > 0) {
            this.TryToDisconnect();
        }
    }
}

ComponentManager.setUtility('CreateOrConnectHelper', CreateOrConnectHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');